/**
 * @voltxampere/ui — SCR C106 variant (Sprint 44-2, placeholder)
 *
 * PLACEHOLDER. Silicon-controlled rectifier (latching thyristor);
 * gerçek SCR stamp (gate trigger + latched-on state + holding
 * current) Sprint 47+ engine extension #4 ile aktif. Şu anki
 * stamp'te `diode` schemaType üzerinden forward-conducting
 * davranış gösterir.
 *
 * Reference: TI C106M — TO-126. V_DRM = 600 V, I_T(RMS) = 4 A,
 * V_TM = 1.5 V (at I_TM = 6 A), I_GT = 200 µA, I_H = 5 mA. Half-wave
 * rectified motor control + crowbar protection workhorse.
 *
 * Engine zero-diff invariant honored — canonical `diode` engine type
 * via schemaType. Inspector "SCR latching thyristor — Sprint 47+
 * scope" warning ileride eklenir.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diode } from "../diode.js";
export const powerScrC106 = {
    id: "c106",
    nameTr: "C106M (SCR 600V/4A, TO-126, placeholder)",
    nameEn: "C106M (SCR 600V/4A, TO-126, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: diode.viewBox,
    terminals: diode.terminals,
    defaultLabel: "Q",
    defaultValue: "C106M",
    schemaType: "diode",
    defaultParams: { saturationCurrent: 1e-12, ideality: 1.5 },
    renderSVG: () => diode.renderSVG(),
};
//# sourceMappingURL=power-scr-c106.js.map